<template>
  <div class="">
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <div class="wp_single wp_column_article">
            <div class="wp_entry">
              <div class="wp_articlecontent">
                <div class="head">
                  <!-- <div>
                    <img src="@/assets/images/jtwh1.jpg" alt="" width="450px" />
                  </div>
                  <div>
                    <img src="@/assets/images/jtwh2.jpg" alt="" width="450px" />
                  </div>
                  <div>
                    <img src="@/assets/images/jtwh3.jpg" alt="" width="450px" />
                  </div>
                  <div>
                    <img src="@/assets/images/jtwh4.jpg" alt="" width="450px" />
                  </div>
                  <div>
                    <img src="@/assets/images/jtwh6.jpg" alt="" width="450px" />
                  </div>
                  <div><div class="feature-slide-list"></div></div>
                  <div class="wh5">
                    <img src="@/assets/images/jtwh5.jpg" alt="" width="450px" />
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  beforeDestroy() { },
  methods: {},
};
</script>
<style lang='scss' scoped>
.mgb80 {
  margin-bottom: 80px;
  margin-top: 30px;

  .content-web {
    display: flex;
    width: 1200px;
    min-width: 1200px;
    margin: 0 auto;

    .inner_content_right {

      // float: right;
      //   box-sizing: border-box;
      //   width: 960px;
      //   min-height: 600px;
      //   margin-left: 20px;
      //   background-color: #fff;
      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }

      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;
        ;

        .head {
          .wh5 {
            padding: 40px 60px 20px;
            text-align: center;
          }

          .feature-slide-list {
            background: #ddd;
            width: 925px;
            height: 25px;
          }
        }
      }

      .text {
        text-indent: 45px;
      }

      .ltd {
        float: right;
      }
    }
  }
}
</style>